import './Rodape.css';


export default function Rodape(props) {
    return (
        <footer>
            <div>

                <div>
                    {/* <Logo /> */}
                    <h2>Androlynx</h2>
                </div>

                <div>
                    <h2><a href="https://2022.spaceappschallenge.org/challenges/2022-challenges/through-the-looking-glass/teams/androlynx/project">Our project</a> </h2>
                    
                </div>

                <div>
                    <h2><a href="https://www.figma.com/file/7rQkXe62DQ33x7La8Dm4tD/Androlynx---game?node-id=0%3A1">Figma</a> </h2>
                    
                </div>

                <div>
                    <h2><a href="https://github.com/jhonatxnz/Androlynx-Nasa">GitHub</a> </h2>
                    
                </div>

                <div>
                    <h2><a href="/colaboradores">Collaborators</a> </h2>
                </div>
            </div>
        </footer>
    );
}